import React from "react";
import { useEffect } from "react";
function Header() {
    useEffect(() => {
        const options = {
            threshold: 1,
        };
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                entry.target.classList.toggle(
                    "top-down-animation-show",
                    entry.isIntersecting
                );
                if (entry.isIntersecting) observer.unobserve(entry.target);
            });
        }, options);

        const el = document.querySelector(".top-down-animation");
        observer.observe(el);
    }, []);

    return (
        <header className="w-full h-16 text-white px-9 py-9">
            <div className="flex flex-auto items-center justify-between max-w-screen-lg my-0 mx-auto top-down-animation">
                <p style={{ fontSize: "1.8rem", fontWeight: "500" }}>
                    naveenrk.official@gmail.com
                </p>
                <div className="flex gap-9 items-center justify-center">
                    <a
                        href="https://www.linkedin.com/in/naveen-rk/"
                        className="text-3xl hover:underline font-medium cursor-pointer"
                        target="_blank"
                        rel="noreferrer"
                    >
                        LinkedIn
                    </a>

                    <a
                        href="https://www.instagram.com/naveen.rk_"
                        className="text-3xl hover:underline font-medium cursor-pointer"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Instagram
                    </a>

                    <a
                        href="https://www.youtube.com/channel/UC9pSwOKio1gWGccObXsyu4A"
                        className="text-3xl hover:underline font-medium cursor-pointer"
                        target="_blank"
                        rel="noreferrer"
                    >
                        YouTube
                    </a>
                </div>
            </div>
        </header>
    );
}

export default Header;
